//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiDotsVertical } from '@mdi/js'
import ChartjsComponentPolarAreaChart from './charts-components/ChartjsComponentPolarAreaChart.vue'
import chartjsData from './chartjsData'

export default {
  components: {
    ChartjsComponentPolarAreaChart,
  },
  setup() {
    const items = [{ title: 'Last 28 Days' }, { title: 'Last Month' }, { title: 'Last Year' }]

    return {
      items,
      chartjsData,
      icons: {
        mdiDotsVertical,
      },
    }
  },
}
